import { ReactNode } from 'react';

import { cx } from '@libs/classnames';

import styles from './ClubCreateModal.module.css';
import { ModalCard } from '@ui/components/ModalCard';

export type Props = {
  className?: string;
  children?: ReactNode;
  onClose: () => void;
};

export function ClubCreateModal({ className, children, onClose }: Props) {

  return (
    <ModalCard
      className={cx(className, styles.root)}
      title="Создать клуб"
      onClose={onClose}
    >
      { children }
    </ModalCard>
  );
}
